import React from 'react';
import {ReactComponent as ArrayIcon} from '../../../../../assets/main/groups/main-table/array.svg';
import {studentData} from "./index";
import {ScheduleRow} from "./schedule-row/ScheduleRow";
import {useAppSelector} from "common/hook";
import {NavLink} from "react-router-dom";


export const ScheduleTable = () => {
    const userData = useAppSelector(state => state.testViewAnswerId.serverData?.data?.user)
    return (
        (userData && (
            <div className="data-tbl inner-group-students-tbl">
                <ScheduleRow/>
                <div className="row full-width-mobile" key={userData?.id}>
                    <div className="col student-col full-width-mobile">
                        <span className="col-title">Студент</span>
                        <div className="student-data-box">
                            <div className="avatar">
                                <img src={userData?.avatar} alt={userData?.fullName}/>
                                <span className={`status-label ${userData?.onlineStatus}`}/>
                            </div>
                            <div className="student-data">
                                <p className="name">
                                    <NavLink
                                        to={`/groups/${userData?.groupId}/students-pages/${userData?.id}`}>{userData?.fullName}</NavLink> {" "}
                                </p>
                                {userData.cuts !== null || userData.efficiency !== null ? (
                                <div className="data-statistic">
                                    {userData.cuts !== null && (
                                    <div className="data-statisitc-item">
                                        <span className="data-statistic-text">Срезы {" "}</span>
                                            <span
                                                className={`data-statistic-val completed-count ${userData.cuts > 50 ? '' : 'low'}`}>
                                                    {userData?.cuts}%
                                                </span>
                                    </div>
                                    )}
                                    {userData.efficiency !== null && (
                                    <div className="data-statisitc-item">
                                        <span className="data-statistic-text">Эффективность {" "}</span>
                                            <span
                                                className={`data-statistic-val completed-count ${userData.efficiency > 50 ? '' : 'low'}`}>
                                                {userData?.efficiency}%
                                              </span>
                                    </div>
                                    )}
                                </div>
                                ) : null}
                            </div>
                        </div>
                    </div>
                    <div className="col first-level-col">
                        <span className="col-title">Начальный уровень</span>
                        <p>{userData?.beginningLanguageLevel}</p>
                    </div>
                    <div className="col current-level-col">
                        <span className="col-title">Текущий уровень</span>
                        <p>{userData?.currentLanguageLevel}</p>
                    </div>
                    <div className="col classes-attended-col align-right">
                        <span className="col-title">Посещенные занятия</span>
                        <p>{userData?.attendedClasses}</p>
                    </div>
                    <div className="col passes-col align-right">
                        <span className="col-title">Пропуски</span>
                        <p>{userData?.missingClasses}</p>
                    </div>
                    <div className="col hometasks-col align-right">
                        <span className="col-title">Домашние задания</span>
                        <span>{userData?.homeworks}<span>/{userData?.homeworksAll}</span>
                    </span>
                    </div>
                    <div className="col btn-link-col">
                    <span className="circle-arrow-btn">
                         <NavLink
                             style={{borderBottom: 'none', textShadow: 'none'}}
                             className="circle-arrow-btn"
                             to={`/groups/${userData?.groupId}/students-pages/${userData?.id}`}
                         >
                        <ArrayIcon/>
                    </NavLink>
                    </span>
                    </div>
                </div>

            </div>
        ))
    );
};

